import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PrinterIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import printDocument from '../../utils/printDocument';
import legalDocumentPrintStyles from '../../utils/legalDocumentPrintStyles';
import './LegalDocumentActions.css';

// Reusable print/save controls for mandatory legal agreement screens (ToS,
// lease agreement, etc). `targetRef` must point at the document content
// itself, not a scroll-box wrapper — printing a scrolled/clipped container
// would cut off content that isn't currently visible on screen.
export default function LegalDocumentActions({ targetRef, title, className = '' }) {
    const [isPrinting, setIsPrinting] = useState(false);

    const handlePrint = async () => {
        if (isPrinting) return;
        setIsPrinting(true);
        await printDocument(targetRef.current, {
            title,
            extraStyles: legalDocumentPrintStyles,
        });
        setIsPrinting(false);
    };

    return (
        <div className={`legal-doc-actions ${className}`}>
            <button type="button" className="legal-doc-actions__btn" onClick={handlePrint} disabled={isPrinting}>
                <PrinterIcon className="legal-doc-actions__icon" aria-hidden="true" />
                Print
            </button>
            <button type="button" className="legal-doc-actions__btn" onClick={handlePrint} disabled={isPrinting}>
                <ArrowDownTrayIcon className="legal-doc-actions__icon" aria-hidden="true" />
                Save as PDF
            </button>
        </div>
    );
}

LegalDocumentActions.propTypes = {
    targetRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
};
